import { hasProperty } from '../util';
export function isUnitSpec(spec) {
  return hasProperty(spec, 'mark');
}